export default "__VITE_ASSET__CMvafH4s__"